module.exports = __webpack_public_path__ + "img/hot.20a55dfb.svg";